export const formatCurrency = val => {
  const num = parseFloat(val)
  return isNaN(num) ? '' : num.toFixed(2)
}

export const formatInteger = val => {
  const num = parseFloat(val)
  return isNaN(num) ? '' : Math.round(num).toString()
}

export const formatCheckCountColumn = val => {
  const num = Number(val)

  if (!isNaN(num) && val !== '') {
    const roundedNum = Math.round(num).toString()
    return roundedNum
  }

  return val
}